import { Card, CardContent, CardHeader, TableRow, Typography } from '@mui/material'
import React from 'react'
import IconTooltipButton from '../../../../button/IconTooltipButton'
import { useNavigate, useParams } from 'react-router-dom';
import { setCurrentCurriculum } from '../../../../../store/actions/assessment.actions';
import { useDispatch, useSelector } from 'react-redux';

const CardClass = ({
  title,
  columns = [],
  _id,
  curriculumId,
  ...props
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { curriculumId: paramsCurriculumId, studentId } = useParams();
  const redirectStudentId = studentId ? `${studentId}/` : "";
  const onPreview = () => {
    const curriculumid = curriculumId || paramsCurriculumId;
    dispatch(setCurrentCurriculum(curriculumid));
    navigate(`/dashboard/${redirectStudentId}classes/${curriculumid}/preview/${_id}`);
  };

  return (
    <Card>
      <CardHeader
        title={title}
        titleTypographyProps={{ variant: 'h6', color: 'secondary', align: 'center' }}
        className='bg-primary'
        action={
          <IconTooltipButton
            id={`preview-${_id}`}
            title='Preview'
            color='secondary'
            icon='expand-alt'
            onClick={onPreview}
          />
        }
      >
      </CardHeader>
      <CardContent className='p-0' style={{ padding: 0 }}>
          {
            columns.filter((col) => col.show).filter((col) => col.key !== 'code').map((col, index) => {
              if (col.field === 'code') return null
              return (
                <TableRow key={`row-${_id}-${col.key}-${index}`} component={'div'} className='grid grid-cols-3 items-center gap-4 py-2 px-2'>
                  <Typography variant='inherit' className='font-bold text-right text-ellipsis' color='primary'>{col.label}</Typography>
                  <Typography component='div' variant='inherit' className='col-span-2 max-w-150'>{props[col.key]}</Typography>
                </TableRow>
              )
            })
          }
          <div />
      </CardContent>
    </Card>
  )
}

export default CardClass